import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Button from '../../../1_Atoms/Button/Button';
import Input from '../../../1_Atoms/Forms/Input/Input';
import { Svg } from '../../../1_Atoms/Svg/Svg';
import { languageController } from '../../../../controllers/language/languageController';

function DealerSearch({
  onSubmit,
  onGeolocationSubmit,
  initKeyword,
  statusMessage,
  errorMessage
}) {
  const [dealerKeyword, setDealerKeyword] = useState('')

  useEffect(() => {
    if (initKeyword) {
      setDealerKeyword(initKeyword)
    }
  }, [initKeyword])

  return (
    <div className="mz-dealer-search">
      <div className="mz-container">
        <div className="mz-dealer-search__inner mz-full-width grid-inner-2-10-md grid-inner-2-10-lg">

          <form 
            className="mz-dealer__input"
            onSubmit={(e) =>{
              e.preventDefault();
              onSubmit(dealerKeyword);
            }}
          >
              <Input
                type="text"
                name="dealer"
                label={languageController.getCopy('findDealer', 'searchInput')}
                value={dealerKeyword}
                onChange={(e) => setDealerKeyword(e.target.value)}
                maxLength={50}
              />
              <Button
                type="submit"
                className="mz-btn--primary"
                label={languageController.getCopy('findDealer', 'searchSubmit')}
              />
              {
                errorMessage && (
                  <div className="mz-dealer-search__error-message">{errorMessage}</div>
                )
              }
          </form>

          <p className="text--grey paragraph">{languageController.getCopy('findDealer', 'or')}</p>

          <Button
            className="mz-btn--primary mz-dealer__giolocation-btn"
            label={languageController.getCopy('findDealer', 'useGeolocation')}
            onClick={onGeolocationSubmit}
            buttonIcon={<Svg type="locationairplane" size={1.2} colour="white" style={{ top: '1px' }} />}
            buttonIconPosition="right"
          />

          <div className={`mz-dealer-search__status-message ${statusMessage.text ? 'active' : ''}`}>
            <Svg type={statusMessage.isError ? 'warning' : 'sync'} size={1} colour="white" style={{ top: '1px' }} />
            <span className="interactive">{statusMessage.text}</span>
          </div>

        </div>
      </div>
    </div>
  )
}

DealerSearch.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onGeolocationSubmit: PropTypes.func.isRequired,
  initKeyword: PropTypes.string,
  statusMessage: PropTypes.object,
  errorMessage: PropTypes.string,
}

export default DealerSearch

